import styled from 'styled-components'

export const FormContainer = styled.form`
  padding: 0 20px 20px;
`

export const Divider = styled.div`
  margin-top: 16px;
  text-align: center;
`

export const ButtonGroup = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 10px;
`
